import React from 'react';
import Grid from '@material-ui/core/Grid';
import ExpandingList3 from '../../ExpandingList/ExpandingList3';

const LeadershipPosition = ({ classes, form, setForm, disabled, version }) => (
  <Grid item xs={12} align="left">
    <Grid item xs={12}>
      <section align="left" className={classes.sectionTitle}>
        Leadership Positions
      </section>
      {version === 2 && (
        <div align="left" style={{ marginTop: -10, marginBottom: 10 }}>
          Please enter the school year, duration and provide a brief description of any leadership positions that you are/were involved in.
        </div>
      )}
    </Grid>
    <Grid container direction="row" className={classes.unprintedContent}>
      <Grid item xs={12}>
        <Grid container direction="row" className={classes.rowSpacer}>
          <Grid item xs={2} sm={2} md={2} lg={2} className={classes.rowSpacer}>
            <label>School Year</label>
          </Grid>
          {version === 2 ? (
            <>
              <Grid item xs={3} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>Duration</label>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Position/Description</label>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={3} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>Position</label>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Description</label>
              </Grid>
            </>
          )}
        </Grid>
        <ExpandingList3
          className={classes.unprintedContent}
          form={form}
          setForm={setForm}
          listname="leadershipPositions"
          rowsRequired={1}
          disabled={disabled}
          field1="schoolYear"
          field1Cols={2}
          field1MaxLength={20}
          field2={version === 2 ? 'duration' : 'position'}
          field2Cols={3}
          field2MaxLength={100}
          field3={version === 2 ? 'positionOrDescription' : 'description'}
          field3Cols={6}
          field3MaxLength={255}
          version={version}
          inputHeight={36}
        />
      </Grid>
    </Grid>
    <Grid container direction="row" className={classes.printedContent}>
      <Grid item xs={12}>
        <Grid container direction="row" className={classes.rowSpacer}>
          {version === 2 ? (
            <>
              <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>School Year</label>
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>Duration</label>
              </Grid>
              <Grid item xs={4} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Position/Description</label>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>School Year</label>
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>Position</label>
              </Grid>
              <Grid item xs={4} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Description</label>
              </Grid>
            </>
          )}
        </Grid>
        {Array.isArray(form?.leadershipPositions) &&
          form.leadershipPositions.map((e, i) => (
            <Grid container direction="row" className={classes.rowSpacer} key={i}>
              <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                {e.schoolYear}
              </Grid>
              {version === 2 ? (
                <>
                  <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                    {e.duration}
                  </Grid>
                  <Grid item xs={4} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                    {e.positionOrDescription}
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                    {e.position}
                  </Grid>
                  <Grid item xs={4} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                    {e.description}
                  </Grid>
                </>
              )}
            </Grid>
          ))}
      </Grid>
    </Grid>
  </Grid>
);

export default LeadershipPosition;
